// extracted by mini-css-extract-plugin
module.exports = {"CheckboxInput":"style_CheckboxInput__3h2Vl","disabled":"style_disabled__23UnF","input":"style_input__2e4Pv","checkmark":"style_checkmark__Rawn2","label":"style_label__2pBH2"};